import Vue from "vue"
import Vuex from "vuex"
import api from "../api/api_modules";
import until from "../assets/js/until";
import { get } from "js-cookie";

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userName: "",
    userInfo: null,
    token: null,
    menu: [],
    menuItems: [],
    doge: 0,
    // imgApiUrl: "https://sxs_api.xixunyun.cn/api",
    imgApiUrl: "",
    baseUrl: "https://sxsapi.qxiaoyun.com/",
    posts: [],
    checkActivities: [],
    devices: [],
    bigDevices: [],
    sbflh: [],
    gbm: [],
    allEqs: [],
    dangerCategorys: [],
    dangerLevels: [],
    userTitles: [],
    educationLevels: [],
    zyjszwList: [],
    grades: [],
    params: [],
    termms: [],
    organs: null,
    trainRooms: [],
    trainRoomsTree: [],
    consumeIntos: [],
    standardList: [],
    checks: [],
    funds: [],
    years: [],
    yearTrems: [],
    adminMeunItems: [
      { "title": "学校管理", "icon": "el-icon-school", "path": "/schoolConfig", "module": "jbxxgl", "index": "a1" },
      { "title": "Agent 管理", "icon": "el-icon-s-tools", "path": "/agentManage", "module": "jbxxgl", "index": "a2" },
      { "title": "公共菜单管理", "icon": "el-icon-menu", "path": "/menuManage", "module": "jbxxgl", "index": "a3" },
    ],
    termData: [],
    defaultModules: [
      { label: "基本信息管理", module: "jbxxgl" },
      { label: "课程管理", module: "kcgl" },
      { label: "安全管理", module: "aqgl" },
      { label: "设备管理", module: "sbgl" },
      { label: "危化品管理", module: "whpgl" },
      { label: "耗材管理", module: "hcgl" },
      { label: "物联网管理", module: "wlwgl" },
      { label: "数据统计", module: "sjtj" },
      { label: "AI实验实训助手", module: "sysxzs" },
      // { label: "在线安全考试管理", module: "dcwj" },
      // { label: "安全培训与考试系统", module: "pxksxt" }
    ],
    themeTitle: '实验实训',
    modules: [],
    currentModule: 'jbxxgl',
    mathMethods: [{ value: 'plus', label: "加" }, { value: 'minus', label: "减" }],
    sexs: [{ value: 1, label: "男" }, { value: 2, label: "女" }, { value: 3, label: "未知" }],
    qItemType: [{ value: 1, label: "学生评价课程" }, { value: 2, label: "老师评价学生" }],
    reviewStatus: [{ value: 1, label: "待审核" }, { value: 2, label: "已通过" }, { value: 3, label: "已拒绝" }],
    reviewStatus2: [{ value: 1, label: "待审核" }, { value: 2, label: "已通过" }, { value: 3, label: "已拒绝" }],

    applyStatus: [{ value: 'apply', label: "待审核" }, { value: 'pass', label: "已通过" }, { value: 'refuse', label: "已拒绝" }],
    applyStatus1: [{ value: 0, label: "待审核" }, { value: 1, label: "已通过" }, { value: 2, label: "已拒绝" }],
    applyStatus2: [{ value: 1, label: "待审核" }, { value: 2, label: "已通过" }, { value: 3, label: "已拒绝" }, { value: 4, label: "已借出" }, { value: 5, label: "已归还" }],
    borrowStatus: [{ value: 1, label: "未归还" }, { value: 2, label: "已归还" }, { value: 3, label: "已逾期" }],
    planStatus: [{ value: 0, label: "未开始" }, { value: 1, label: "进行中" }, { value: 2, label: "已结束" }],
    whStatus: [{ value: '1', label: "合格" }, { value: '2', label: "有隐患" }, { value: '3', label: "有故障" }],
    term: [{ value: 1, label: "第一学期" }, { value: 2, label: "第二学期" }],
    terms: ['上学期', '下学期'],
    repairs: [{ value: 0, label: "维修中" }, { value: 1, label: "维修完毕" }],
    keeps: [{ value: 0, label: "维护中" }, { value: 1, label: "维护完毕" }],
    // roomType: [{ value: "SIMULATION_TRAINING_ROOM", label: "仿真实验实训室（仿真软件）" }, { value: "PRODUCTIVE_TRAINING_BASE", label: "生产性实训基地（生产项目）" }, { value: "VIRTUAL_SIMULATION_TRAINING_BASE", label: "虚拟仿真实训基地（虚拟仿真实验项目）" }, { value: "SKILL_CLASSROOM", label: "技能教室（典型技能训练项目）" }],
    roomType: [{ value: 1, label: "教学为主" }, { value: 2, label: "科研为主" }, { value: 3, label: "其他" }],
    roomCategory: [{ value: 1, label: "国家级实验教学示范中心" }, { value: 2, label: "省级实验教学示范中心" }, { value: 3, label: "按平台建设的校、院（系）实验室" }, { value: 4, label: "其它实验室" }],
    baseType: ['大学生校外实践教学基地', '校内虚拟仿真实训中心', '校内生产性实训基地', '其他校内实训基地'],
    weeks: ['星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期日'],
    consumTypes: ['日常教学', '技能大赛', '科技技能节项目'],
    uses: ['投入使用 ', '未投入使用'],
    isLabels: ["是", "否"],
    periodFrom: ["上课时间", "其余时间"],
    computerTypes: [{ value: 'teacher', label: "教师机" }, { value: 'student', label: "学生机" }],
    iss: [{ value: 0, label: "否" }, { value: 1, label: "是" }],
    exam_status: [{ value: 0, label: "未通过" }, { value: 1, label: "已通过" }],
    certificate_status: [{ value: 0, label: "未获得" }, { value: 1, label: "有效" }],
    isEffect: [{ value: 0, label: "无效" }, { value: 1, label: "生效" }],
    badStatus: [{ value: 0, label: "正常" }, { value: -1, label: "废弃" }],
    checkStatus: [{ value: 0, label: "草稿" }, { value: 1, label: "执行中" }, { value: 2, label: "已完成" }],
    rectifyStatus: [{ value: 1, label: "评估" }, { value: 2, label: "整改" }, { value: 3, label: "验证" }],
    zgStatus: [{ value: 1, label: "待整改" }, { value: 2, label: "审批中" }, { value: 3, label: "整改完成" }],
    troubleStatus: [{ value: 0, label: "未处理" }, { value: 1, label: "已整改" }],
    freeStatus: [{ value: 0, label: "登记" }, { value: 1, label: "整改" }, { value: 2, label: "关闭" }],
    targetTypes: [{ value: 0, label: "全校" }, { value: 1, label: "院系" }, { value: 2, label: "实验实训室" }],
    characters: [{ value: 1, label: "公共基础实验室" }, { value: 2, label: "专业基础实验室" }, { value: 3, label: "专业实验室" }],
    characterTypes: [{ value: 1, label: "实验型" }, { value: 2, label: "技能实训型" }, { value: 3, label: "综合型" }],
    isOpens: [{ value: 0, label: "关闭" }, { value: 1, label: "开启" }],
    courseResourceStatus: [{ value: '0', label: "未发布" }, { value: '1', label: "已发布" }, { value: '2', label: "已作废" }],
    isSbOpens: [{ value: 0, label: "关闭" }, { value: 1, label: "启用" }],
    eqSource: [{ value: 1, label: "购置" }, { value: 2, label: "自制" }, { value: 3, label: "捐赠" }, { value: 3, label: "校外调入" }],
    syfx: [{ value: 1, label: "教学为主" }, { value: 2, label: "科研为主" }, { value: 3, label: "其它" }],
    xz: [{ value: 1, label: "在用" }, { value: 2, label: "多余" }, { value: 3, label: "待修" }, { value: 4, label: "待报废" }, { value: 8, label: "降档" }, { value: 9, label: "其它" }],
    xxzt: [{ value: 1, label: "未学习" }, { value: 2, label: "学习中" }, { value: 3, label: "已学习" }, { value: 4, label: "考试未通过" }, { value: 5, label: "考试已通过" }],
    fbzt: [{ value: 0, label: "未发布" }, { value: 1, label: "已发布" }],
    aqxxzt: [{ value: 1, label: "未学习" }, { value: 2, label: "学习中" }, { value: 3, label: "已学习" }, { value: 4, label: "考试未通过" }, { value: 5, label: "考试已通过" }],
    activityStatus: [{ value: 0, label: "未开始" }, { value: 1, label: "进行中" }, { value: 2, label: "已结束" }],
    syszt: [{ value: 1, label: "正常" }, { value: 2, label: "有隐患" }, { value: 3, label: "优秀实验室" }],
    frequencys: [{ value: 'daily', label: "每日" }, { value: 'weekly', label: "每周" }, { value: 'monthly', label: "每月" }],
    zxjczt: [{ value: 1, label: "合格" }, { value: 2, label: "不合格" }, { value: 3, label: "不适用" }],
    yhlevel: [{ value: 1, label: "普通" }, { value: 2, label: "紧急" }],
    darkLevel: ['一星', '二星', '三星'],
    periods: ['每周一次', '每两周一次', '每月一次', '每季度一次'],
    safePeriods: [{ value: 1, label: "每周一次" }, { value: 2, label: "每两周一次" }, { value: 3, label: "每月一次" }, { value: 4, label: "每季度一次" }],
    extinguishs: ['禁止用水', '沙土掩埋', '灭火毯', '干粉灭火', '二氧化碳灭火', 'D类灭火'],
    levels: ["A", "B", "C", "D"],
    qualitys: ["国家级", "省级", "部级", "无"],
    supports: ["国家部委", "地方政府", "高校及其它科研机构", "企业", "无"],
    courseSources: ["媒体素材", "试题", "试卷", "课件", "案例", "文献资料", "网络课程", "教学工具软件（包括教学APP）"],
    paperTypes: [{ value: 'exam', label: "考试卷" }],
    questionTypes: ["单选", "多选" ,"判断"],
    engCods: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'],
    experimentTypes: ['实验类型(演示性', '验证性', '综合性', '设计研究类', '其它类', '演示性网络实验', '验证性网络实验', '综合性网络实验', '设计研究类网络实验', '其它类网络实验'],
    experimentCategorys: ["基础", "专业基础", "专业", "其他"],
    experimentRequirements: ["必修", "选修", "其他"],
    participantTypes: ["博士生", "硕士生", "本科生", "专科生", "其他"],
    agreements: ["签署", "未签", "续签"],
    cooperations: ["终止", "正常"],
    difficulty: ["简单", "中等", "困难"],
    materialSources: ['系统预置', '用户上传'],
    extensions:['pdf','mp4','ogm','wmv','avi','ogv','webm','mov','asx','mpeg','m4v'],
    questionSources: ['系统预置', '用户上传', 'AI生成'],
    rolesType: [{ value: 1, label: "全校" }, { value: 2, label: "院系" }, { value: 3, label: "专业" }, { value: 4, label: "个人" }],
    // 试卷:状态(0未发布 1已发布 2已停用)、组卷类型
    // paperStatus: [{ value: 0, label: "未发布" }, { value: 1, label: "已发布" }, { value: 2, label: "已停用" }],
    paperMakeTypes: ['人工组卷', 'AI组卷'],
    // 安全课程表单选项(考试前置/学习对象/次数用尽后)
    preExamOptions: ['无需签署承诺书', '考试前需签署最新版本安全承诺书'],
    userTypeOptions: ['老师', '学生', '全部（老师+学生）'],
    endDoingOptions: ['达到上限后禁止继续考试', '重新学习后重置次数并循环'],
    relys: ['机关', '事业单位', '国有企业', '民营（私营）企业', '部队', '社会组织机构', '国际组织机构', '国防科工机构', '财政金融机构', '其他'],
    experiments: ["基础", "专业基础", "专业", "其他"],
    projects: ['演示性', '验证性', '综合性', '设计研究类', '其它类', '演示性网络实验', '验证性网络实验', '综合性网络实验', '设计研究类网络实验', '其它类网络实验'],
    industrys: [],
    cys: ['第一产业', '第二产业', '第三产业'],
    requires: ['必修', '选修', '其他'],
    sections: [],
    provinces: [],
    citys: [],
    districts: [],
    cycles: ["本周", "每周", "单周", "双周", "自定义"],
    dangerLevells: ['Ⅰ级', 'Ⅱ级', 'Ⅲ级', 'Ⅳ级'],
    dangerTypes: ['爆炸/反应失控风险', '易燃易爆风险', '氧化/助燃风险', '毒害风险', '腐蚀风险', '窒息/高压风险', '环境污染风险', '治安管控风险', '污染耗材风险', '无'],
    chemicalCates: ['普通化学品', '危险化学品'],
    useStatus: [{ value: 1, label: "正常" }, { value: 2, label: "已用完" }, { value: 3, label: "已废弃" }],
    jddjms: [{ value: "10", label: "国家级" }, { value: "20", label: "省部级" }, { value: "30", label: "地市级" }, { value: "40", label: "区县级" }, { value: "50", label: "乡镇级" }, { value: "60", label: "校级" }, { value: "61", label: "院系级" }, { value: "62", label: "专业级" }, { value: "70", label: "国际" }],
    chemicalUnit: ['盒', '支', '套', '瓶', 'L', 'mL', 'μL', 'g', 'kg', 'mg', 'μg', 'lb', 'gal', 'ft³', 'mol/L', 'mmol/L', 'g/L', 'mg/mL', 'ppm', 'ppb', '%', 'atm', 'kPa', 'mmHg', 'bar'],
    h5HideMenu: ["/quickEntry", "/trainOutItemConfig", "/TermManage", "/RoleManage", "/organManage", "/userList", "/webSiteStyle", "/equipmentCountsByStructure", "/yearSafeReport"],
    singlePageMenu:["/trainingSafeInfo"]
  },
  getters: {
    // menuItems 数据来自接口 api/menu/setting/list（见 actions.getMenuItems）
    menuItems: (state) => state.menuItems,
  },
  mutations: {
    setProvinces(state, newVal) {
      state.provinces = newVal
    },
    setCitys(state, newVal) {
      state.citys = newVal
    },
    setDistricts(state, newVal) {
      state.districts = newVal
    },
    setDangerLevels(state, newVal) {
      state.dangerLevels = newVal
    },
    setDangerCategorys(state, newVal) {
      state.dangerCategorys = newVal
    },
    setUserName(state, newVal) {
      state.userName = newVal
    },
    setUserTitles(state, newVal) {
      state.userTitles = newVal
    },
    setEducationLevels(state, newVal) {
      state.educationLevels = newVal
    },
    setZyjszwList(state, newVal) {
      state.zyjszwList = newVal
    },
    setPosts(state, newVal) {
      state.posts = newVal
    },
    setModules(state, newVal) {
      state.modules = newVal
    },
    setUserInfo(state, newVal) {
      state.userInfo = JSON.parse(newVal)
    },
    setOrgans(state, newVal) {
      state.organs = JSON.parse(newVal)
    },
    setMenu(state, newVal) {
      state.menu = JSON.parse(newVal)
    },
    setMenuItems(state, newVal) {
      state.menuItems = newVal
    },
    setToken(state, newVal) {
      state.token = newVal
    },
    setDoge(state, newVal) {
      state.doge = newVal
    },
    setTrainRooms(state, newVal) {
      state.trainRooms = newVal
    },
    setTrainRoomsTree(state, newVal) {
      state.trainRoomsTree = newVal
    },
    setConsumeIntos(state, newVal) {
      state.consumeIntos = newVal
    },
    setFunds(state, newVal) {
      state.funds = newVal
    },
    setYears(state, newVal) {
      state.years = newVal
    },
    setTermms(state, newVal) {
      state.termms = newVal
    },
    setParams(state, newVal) {
      state.params = newVal
    },
    setGrades(state, newVal) {
      state.grades = newVal
    },
    setYearTrems(state, newVal) {
      state.yearTrems = newVal
    },
    setStandards(state, newVal) {
      state.standardList = newVal
    },
    setChecks(state, newVal) {
      state.checks = newVal
    },
    setCheckActivities(state, newVal) {
      state.checkActivities = newVal
    },
    setCurrentModule(state, newVal) {
      state.currentModule = newVal
    },
    setDevices(state, newVal) {
      state.devices = newVal
    },
    setBigDevices(state, newVal) {
      state.bigDevices = newVal
    },
    setSbflh(state, newVal) {
      state.sbflh = newVal
    },
    setGbm(state, newVal) {
      state.gbm = newVal
    },
    setAllEqs(state, newVal) {
      state.allEqs = newVal
    },
    setIndustrys(state, newVal) {
      state.industrys = newVal
    },
    setSection(state, newVal) {
      state.sections = newVal
    },

  },
  actions: {
    // 公共菜单：menuItems 数据来源（api/menu/linked/list）
    async getMenuItems(context, params = {}) {
      console.log('getMenuItems action called');
      if (!params.force && context.state.menuItems && context.state.menuItems.length > 0) {
        return
      }
      let res = await api.instance.interfaceServer('api/menu/linked/list', 'get', { size: 999 }, { isLoadd: false });
      if (res && res.code === 0) {
        context.commit('setMenuItems', until.methods.normalizeMenuData(until.methods.extractMenuListData(res.data)));
      }
    },
    async getTarinMent(context, params = {}) {
      let res = await api.instance.getTarinMent(params);
      if (res.code == 0) {
        let arr = []
        if (params.isEmpty) {
          arr.push({
            id: '0',
            training_name: '无'
          })
        }
        context.commit('setTrainRooms', arr.concat(res.data))
      }
    },
    async getTarinMentTree(context, params = {}) {
      let res = await api.instance.interfaceServer(`api/training/room/tree`, 'get', params);
      if (res.code == 0) {
        let arr = [], trains = []
        res.data.map(item => {
          if (item.children && item.children.length) {
            trains = trains.concat(item.children)
          }
        })
        context.commit('setTrainRooms', trains)
        context.commit('setTrainRoomsTree', arr.concat(res.data))
      }
    },

    async getProvices(context, params) {
      if (context.state.provinces && context.state.provinces.length) {
        return
      }
      let res = await api.instance.interfaceServer(`api/area/provinces`, 'get', params);
      if (res.code == 0) {
        context.commit('setProvinces', res.data)
      }
    },
    async getCitys(context, params) {
      let res = await api.instance.interfaceServer(`api/area/cities`, 'post', params);
      if (res.code == 0) {
        context.commit('setCitys', res.data)
      }
    },
    async getDistricts(context, params) {
      let res = await api.instance.interfaceServer(`api/area/districts`, 'post', params);
      if (res.code == 0) {
        context.commit('setDistricts', res.data)
      }
    },
    async getSection(context, params) {
      if (context.state.sections && context.state.sections.length > 0) {
        return
      }
      let res = await api.instance.interfaceServer(`api/order_room/rule/orderTime/options`, 'get', params);
      if (res.code == 0) {
        context.commit('setSection', res.data)
      }
    },
    async getSbflh(context, params) {
      if (context.state.sbflh && context.state.sbflh.length > 0) {
        return
      }
      let res = await api.instance.interfaceServer(`api/new_device/category/list`, 'get', params);
      if (res.code == 0) {
        context.commit('setSbflh', res.data)
      }
    },
    async getDangerLevels(context, params = {}) {
      // params.page = 1
      // params.size = 99999
      // if (context.state.dangerLevels&&context.state.dangerLevels.length > 0) {
      //   return
      // }
      let res = await api.instance.interfaceServer(`api/hazard-level-rules/list`, 'get', params);
      if (res.code == 0 && res.data) {
        context.commit('setDangerLevels', res.data.data)
      }
    },
    async getDangerCategorys(context, params) {
      if (context.state.dangerCategorys && context.state.dangerCategorys.length > 0) {
        return
      }
      let res = await api.instance.interfaceServer(`api/hazards/hazardCategory`, 'get', params);
      if (res.code == 0) {
        context.commit('setDangerCategorys', res.data)
      }
    },
    async getGbm(context, params = {}) {
      params.page = 1
      params.size = 99999
      if (context.state.gbm && context.state.gbm.length > 0) {
        return
      }
      let res = await api.instance.interfaceServer(`api/new_device/country/list`, 'get', params);
      if (res.code == 0 && res.data) {
        context.commit('setGbm', res.data.data)
      }
    },
    async getPosts(context, params) {
      let res = await api.instance.interfaceServer(`api/role/menu`, 'get', params);
      if (res.code == 0) {
        context.commit('setPosts', res.data.filter(item => item.value != 1))
      }
    },
    async getIndustrys(context, params) {
      if (context.state.industrys && context.state.industrys.length) {
        return
      }
      let res = await api.instance.interfaceServer(`api/training_base_out/industryList`, 'get', params);
      if (res.code == 0) {
        context.commit('setIndustrys', res.data)
      }
    },
    async getUserTitles(context, params) {
      if (context.state.userTitles && context.state.userTitles.length) {
        return
      }
      let res = await api.instance.interfaceServer(`api/training/room/user/titles`, 'get', params);
      if (res.code == 0) {
        context.commit('setUserTitles', res.data)
      }
    },
    async getEducationLevelList(context, params) {
      if (context.state.educationLevels && context.state.educationLevels.length) {
        return
      }
      let res = await api.instance.interfaceServer(`api/training/room/user/educationLevelList`, 'get', params);
      if (res.code == 0) {
        context.commit('setEducationLevels', res.data)
      }
    },
    async getZyjszwList(context, params) {
      if (context.state.zyjszwList && context.state.zyjszwList.length) {
        return
      }
      let res = await api.instance.interfaceServer(`api/training/room/user/zyjszwList`, 'get', params);
      if (res.code == 0) {
        context.commit('setZyjszwList', res.data)
      }
    },
    async getParams(context, params) {
      let res = await api.instance.getParams(params);
      if (res.code == 0) {
        context.commit('setParams', res.data)
      }
    },
    async getChecks(context, params) {
      let res = await api.instance.interfaceServer(`api/safety_check/form/list/all`, 'get', params);
      if (res.code == 0) {
        context.commit('setChecks', res.data)
      }
    },
    async getStandards(context, params) {
      let res = await api.instance.interfaceServer(`api/safety_check/standard/list`, 'get', params);
      if (res.code == 0) {
        context.commit('setStandards', res.data)
      }
    },
    async getBigDevices(context, params = {}) {
      let data = params
      data.page = 1
      data.size = 99999
      let res = await api.instance.interfaceServer(`api/big/device/list`, 'get', params);
      if (res.code == 0 && res.data) {
        context.commit('setBigDevices', res.data.data)
      }
    },
    async getDevices(context, params = {}) {
      let data = params
      data.page = 1
      data.size = 99999
      let res = await api.instance.interfaceServer(`api/device/list`, 'get', params);
      if (res.code == 0 && res.data) {
        context.commit('setDevices', res.data.data)
      }
    },
    async getCheckActivities(context, params) {
      let res = await api.instance.interfaceServer(`api/safety_check/activity/list/all`, 'get', params);
      if (res.code == 0) {
        context.commit('setCheckActivities', res.data)
      }
    },
    async getConsum(context, params = {}) {
      let data = params
      data.page = 1
      data.size = 99999
      let res = await api.query.getConsumeIntoList(data);
      if (res.code == 0 && res.data) {
        context.commit('setConsumeIntos', res.data.data)
      }
    },
    async getTermms(context, params = {}) {
      if (context.state.termms && context.state.termms.length > 0) {
        return
      }
      let data = params
      data.page = 1
      data.size = 99999
      // let res = await api.query.getTermms(data);
      let res = await api.instance.interfaceServer(`api/school_year/index`, 'get', params);
      if (res.code == 0 && res.data) {
        context.commit('setTermms', res.data.data.map(item => {
          return {
            id: item.id,
            term: `${item.year} ${item.term}`,
            termSplit: `${item.year}|${item.term}`,
            year: item.year.replaceAll("学年", ""),
            termm: item.term
          }
        }))
      }
    },
    async getEqs(context, params = {}) {
      let data = params
      data.page = 1
      data.size = 99999
      // let res = await api.query.getTermms(data);
      let res = await api.instance.interfaceServer(`api/new_device/list`, 'get', params);
      if (res.code == 0 && res.data) {
        context.commit('setAllEqs', res.data.data)
      }
    },
    // async getTermms(context, params = {}) {
    //   let data = params
    //   data.page = 1
    //   data.size = 99999
    //   let res = await api.query.getTermms(data);
    //   if (res.code == 0 && res.data) {
    //     context.commit('setTermms', res.data.data)
    //   }
    // },
    async getFunds(context, params = {}) {
      let res = await api.instance.getFunds(params);
      if (res.code == 0) {
        context.commit('setFunds', res.data)
      }
    },
    async getTrainOutYearConfig(context, params = {}) {
      let res = await api.query.getTrainOutYearConfig(params);
      if (res.code == 0) {
        context.commit('setYears', res.data)
      }
    },
    async getLogoInfo(context) {
      let res = await api.instance.getLogoInfo();
      if (res.code == 0) {
        context.commit('setUserInfo', JSON.stringify(until.methods.deleteNullPrototype(res.data)))
      }
    }
  },
  modules: {

  }
})
